module.exports = __webpack_public_path__ + "bb14d08fbd275325d5264f90c9384d26.png";